export { default as create } from './create';
export { default as validate } from './validate';



// WEBPACK FOOTER //
// ./src/services/api/shortlink/index.ts